/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calories-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M11.318 2.135a.5.5 0 00-.803.139L8.216 7.1 5.771 5.473a.5.5 0 00-.692.14c-1.142 1.72-2.131 3.768-2.131 5.732a6.643 6.643 0 1013.285 0c0-4.032-2.788-7.09-4.915-9.21zm2.524 9.873a.5.5 0 10-.986-.156 3.319 3.319 0 01-2.759 2.76.5.5 0 10.156.985 4.317 4.317 0 003.59-3.589z" _fill="#1F222C"/>'
  }
})
